/* unplugin-vue-components disabled */import script from "./sourceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./sourceCard.vue?vue&type=script&setup=true&lang=js"

import "./sourceCard.vue?vue&type=style&index=0&id=264439fd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-264439fd"]])

export default __exports__